module.exports = __webpack_public_path__ + "static/media/costa-rica-poster.201f6b60.png";